<template>
  <div>
    <v-card width="600px">
      <v-form
        v-model="validRewardForm"
        ref="rewardForm">
        <v-layout row pa-2>
        <v-flex xs1 pt-2 pl-2 pr-2> 
          <v-icon medium>{{rewardIcon[type]}}</v-icon>
        </v-flex>
        <v-flex pt-2 pl-2 pr-2>
          {{ $t(`missionForm.reward.${type}`) }}
        </v-flex>

        <!-- actions -->
        <v-flex layout align-center>

          <v-spacer/>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
              v-if="isLast && !isReadOnly"
              v-on="on"
              color="red"
              @click="deleteReward()"
              >mdi-close
              </v-icon>
            </template>
            <span>{{$t('rewards.tooltips.delete')}} </span>
          </v-tooltip>
        </v-flex>
        </v-layout>

      <v-divider/>

      <v-layout column pl-4 pt-2 pr-4>
        <!-- rewardType dialog -->
        <v-dialog
        v-if="isRewardTypeDialogOpen"
        v-model="isRewardTypeDialogOpen"  
        lazy
        persistent
        width="60%"
        min-height="70%">
          <v-card>
            
            <v-flex layout align-center justify-center>
              <v-card-title class="headline" style="padding-top: 10px; padding-bottom: 10px;" primary-title>
                {{ $t(`rewards.chooseRewardType`)}}
              </v-card-title>
            </v-flex>
            <v-layout row style="padding-bottom: 100px;">
              <v-radio-group
                :class="'missionForm__reward '"
                v-model="type"
                :mandatory="false"
                row          
              >
                <v-flex layout row wrap justify-center>
                  <v-radio
                    v-for="rewardType in rewardTypeList"
                    :key="rewardType"
                    :value="rewardType" 
                    :disabled="hasMissionXPReward && rewardType==='xp' || hasMissionOtherReward && rewardType !== 'xp'"
                  >
                    <v-layout slot="label" column>
                      <div
                        class="MissionForm__rewardIcon elevation-2"
                        v-bind:class="{
                        'MissionForm__rewardIcon--selected': type === rewardType
                        }"
                      >
                        <v-icon x-large>{{ rewardIcon[rewardType]}}</v-icon>
                        <v-icon v-if="rewardType==='xp'" style="font-size:70px;margin-left: -30px;">mdi-numeric-5</v-icon>
                      </div>
                      <span class="rewardTypeLabel">
                        {{
                        $t(`missionForm.reward.${rewardType}`)
                        }}
                      </span>
                    </v-layout>
                  </v-radio>
                </v-flex>
             </v-radio-group>
            </v-layout>
            <v-flex layout align-center justify-center>
              <v-card-text v-if="type">
                {{ $t(`rewards.${type}.globalDescription`)}}
              </v-card-text>
            </v-flex>
            <!--v-flex layout row  pl-2 pr-2-->
            <v-card-actions style="background-color: white;" layout row  pl-2 pr-2 pt-4>
              <v-btn             
              color="primary" 
              outline
              flat
              class=" text-none"
              @click="deleteReward">
                <span>{{ $t('premiumDialog.cancelButtonText') }}</span>
              </v-btn>
              <v-spacer></v-spacer>
              
              <v-btn 
              color="primary" 
              class=" text-none"
              :disabled="!type"
              @click="setReward">
                <span>{{ $t('pathManagement.confirm') }}</span>
              </v-btn>
            </v-card-actions>
            <!--/v-flex-->

          </v-card>
        </v-dialog>


        <!-- infosheet -->
        <v-flex
        v-if="type==='infosheet' && isRewardTypeDialogOpen===false">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-text-field
              v-model="infosheet.name[langEdition]"
              :label="$t('rewards.name')"
              @blur="updateInfosheet"
              :rules="rules.name"
              :disabled="isReadOnly"
              :counter="maxCharName"
              :hint="langEdition!==locale ? infosheet.name[locale] : null"
              :persistent-hint="showHint"
              v-on="on"
              >
              </v-text-field> 
                <language-translator
                  v-if="locale!==langEdition"
                  :langEdition="langEdition"
                  :textToTranslate="infosheet.name[locale]"
                  :type="'name'"
                  @text-translated="updateTranslatedText"
                  slot="append">
                </language-translator>
                
            </template>
            <span> {{$t('rewards.tooltips.name')}} </span>
          </v-tooltip>
          
          <v-container grid-list-md text-xs-center>
          <v-layout row wrap>
            <v-flex xs4
              v-for="(picture,index) in infosheet.pictures" :key="index">
                <image-input
                style="margin-right: 25px;"
                :label="$t('rewards.infosheet.picture')"
                :default="picture"
                :isReadOnly="isReadOnly"
                :key="index"
                :imgKey="index"
                :parent="'rewards'"
                :langEdition="langEdition"
                :isBorderThick="false"
                @change-image-input="updateInfosheetImages"
                @error="onImageError"
                ></image-input>
              
            </v-flex>
            <div
            v-if="infosheet.pictures.length< maxInfosheetPictures"
              class="addImage"
              @click="addRewardPicture()">
              <div>
                <v-icon large color="primary">mdi-plus</v-icon>
              </div>
            </div>


          </v-layout>
          </v-container>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-textarea
              v-model="infosheet.funFact[langEdition]"
              :label="$t('rewards.infosheet.funFact')"
              @blur="updateInfosheet"
              :rules="rules.funFact"
              :disabled="isReadOnly"
              :counter="maxCharFunFact"
              :hint="langEdition!==locale ? infosheet.funFact[locale] : null"
              :persistent-hint="showHint"
              v-on="on"
              >
              </v-textarea> 
                <language-translator
                  v-if="locale!==langEdition"
                  :langEdition="langEdition"
                  :textToTranslate="infosheet.funFact[locale]"
                  :type="'funFact'"
                  @text-translated="updateTranslatedText"
                  slot="append">
                </language-translator>
                
            </template>
            <span> {{$t('rewards.tooltips.funFact')}} </span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-textarea
              v-model="infosheet.description[langEdition]"
              :label="$t('rewards.infosheet.description')"
              @blur="updateInfosheet"
              :rules="rules.description"
              :disabled="isReadOnly"
              :counter="maxCharDescription"
              :hint="langEdition!==locale ? infosheet.description[locale] : null"
              :persistent-hint="showHint"
              v-on="on"
              >
              </v-textarea> 
                <language-translator
                  v-if="locale!==langEdition"
                  :langEdition="langEdition"
                  :textToTranslate="infosheet.description[locale]"
                  :type="'description'"
                  @text-translated="updateTranslatedText"
                  slot="append">
                </language-translator>
                
            </template>
            <span> {{$t('rewards.tooltips.description')}} </span>
          </v-tooltip>

          <v-text-field              
          :label="$t('rewards.infosheet.credits')"
          @blur="updateInfosheet"
          v-model="infosheet.credits"
          :counter="90"
          :disabled="isReadOnly"
          :placeholder="'©'"
          >
          </v-text-field>

          
        </v-flex>

        <!-- xp -->
        <v-flex
        v-if="type=='xp'">          
          <v-text-field
          type="number"
          v-model="xp.value"
          :label="$t('rewards.xp.value')"
          @blur="updateRewardContent"
          :disabled="isReadOnly"
          :rules="rules.xpValue"
           :placeholder="'Ex: 5'"
          >
          </v-text-field>
          <v-text-field
          type="number"
          v-model="xp.errorValue"
          :label="$t('rewards.xp.errorValue')"
          :disabled="isReadOnly"
          @blur="updateRewardContent"
           :placeholder="'Ex: 1'"
          >
          </v-text-field>
        </v-flex>

        <!-- --- object --- -->
        <v-flex column pl-4 pr-4
        v-if="type=='object'">

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-text-field
              :label="$t('rewards.object.text')"
              @blur="updateRewardContent"
              v-model="message[langEdition]"
              :disabled="isReadOnly"
              :counter="90"
              :hint="langEdition!==locale ? message[locale] : null"
              :persistent-hint="showHint"
              v-on="on">
                <language-translator
                  v-if="locale!==langEdition"
                  :langEdition="langEdition"
                  :textToTranslate="message[locale]"
                  :type="'message'"
                  @text-translated="updateTranslatedText"
                  slot="append">
                </language-translator>
              </v-text-field>
            </template>
            <span> {{$t('rewards.tooltips.text')}} </span>
          </v-tooltip>

          <v-layout row class="justify-center" style="padding-left:124px !important;padding-right:124px !important">
          <v-flex column pl-4 pr-4>

          <image-input
            :label="$t('rewards.object.picture')"
            :showHint="showHint"
            :default="object.picture"
            :isReadOnly="isReadOnly"
            :isBorderThick="true"
            :langEdition="langEdition"
            @change-image-input="updateObjectImage"
            @error="onImageError"
          />
          </v-flex>

          <v-flex column class="align-center" pl-4 pr-4>
       
          <media-input
            style="top: 30%;"
            :label="$t('rewards.object.media')"
            :default="object.media.url"
            :isReadOnly="isReadOnly"
            :type="object.media.type"
            :name="object.media.name"
            :width="150"
            @change-media-input="updateObjectMedia"
            @uploading-media="uploadingMedia"
          >
          </media-input>

          </v-flex>
          </v-layout>

        </v-flex>
    

      </v-layout>
      <v-layout>


        <!-- reward rules -->
        <v-flex layout  justify-center align-center
        v-if="rulesToShow">
        <p class="ruleText">
          <span
          v-for="rule in rulesToShow" :key="rule">
            
            <span>
              {{rule}}
            </span>
            <br>
          </span>
        </p>
        </v-flex>
        
      </v-layout>
      </v-form>
    </v-card>

     <text-dialog
      :type="typeTextDialog"
      :isTextDialogOpen="isXPDialogOpen"
      :title="textDialogInformations[typeTextDialog].title"
      :details="textDialogInformations[typeTextDialog].details"
      :explanation="textDialogInformations[typeTextDialog].explanation"
      :cancelButtonText="textDialogInformations[typeTextDialog].cancelButtonText"
      :confirmButtonText="textDialogInformations[typeTextDialog].confirmButtonText"
      @confirm="propagateXP()"
      @cancel="isXPDialogOpen=false">
    </text-dialog>

  </div>
</template>

<script>

import ImageInput from './ImageInput';
import MediaInput from '../components/MediaInput';
import TextDialog from './TextDialog';
import LanguageTranslator from '../components/LanguageTranslator.vue';


export default {
  name: 'rewards',
  components: {
    ImageInput,MediaInput,
    LanguageTranslator,TextDialog
  },
  props: {
  	reward: {
  		type: Object,
      value: null
    },
    rewardId: {
  		type: Number,
      value: null
    },
    isLast: {
      type: Boolean,
      default: false
    },
    missionId: {
      type: String,
      default: null
    },
    pathId: {
      type: String,
      default: null
    },
    langEdition: {
      type: String,
      default: null
    },
    langsEdited: {
      type: Array,
      default: null
    },
    showHint: {
      type: Boolean,
      default: true
    },
    hasMissionXPReward: {
      type: Boolean,
      default: false
    },
    hasMissionOtherReward: {
      type: Boolean,
      default: false
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      id: 1,
      isRewardTypeDialogOpen:false,
      isXPDialogOpen:false,
      typeTextDialog:'propagateReward',
      rewardTypeList:['xp', 'object'], //,'infosheet'],
      validRewardForm:false,
      rewardIcon: { 
        infosheet: 'mdi-information-outline', 
        xp: 'mdi-plus',//'mdi-plus',
        object: 'mdi-toolbox'
      }, 
      type: 'xp',
      value: null,
      oldValue: null,
      message:{fr:'',en:''}, 
      xp: {
        errorValue: null, value:null
      },
      object:{
        picture:{url:'', author:'',legend:{fr:'',en:''}},
        media:{url:'',name:'',type:''}
      },
      infosheetEmpty:{
        name:{fr:'',en:''},
        description:{fr:'',en:''},
        funFact:{fr:'',en:''},
        credits:'',
        pictures:[ {url:'', author:'',legend:{fr:'',en:''}} ]
      },
      maxCharName:50,
      maxCharDescription:1000,
      maxCharFunFact:500,
      maxInfosheetPictures:6,
      rules: {
        name: [
          name => Boolean(name) || this.$t('rewards.rules.name.empty'),
          name => (name && name.length <= this.maxCharName) || this.$tc('rewards.rules.name.length', this.maxCharName),
        ],        
        description: [
          description => (description && description.length <= this.maxCharDescription) || this.$tc('rewards.rules.description.length', this.maxCharDescription),
        ],
        funFact: [
          funFact => (funFact && funFact.length <= this.maxCharFunFact) || this.$tc('rewards.rules.funFact.length', this.maxCharFunFact),
        ],
        xpValue: [
          xp => Boolean(xp) || this.$t('rewards.rules.xp.empty'),
          xp => (xp && typeof parseInt(xp)!=='integer') || this.$tc('rewards.rules.xp.number'),
        ],
        //xp: {
        //  maxvalue: this.$t('rewards.rules.xp.maxvalue')
        //},
      }
    };
  },
  created() {
  	if(this.reward === null) {
  		return;
    }
    this.type=this.reward.type
    this.value=this.reward.value
    this.message.fr= this.reward.message && this.reward.message.fr
    this.message.en= this.reward.message && this.reward.message.en
    this.oldValue = JSON.parse(JSON.stringify(this.value))
    if (this.isRewardObject) {
      this.object = this.reward.object
    } else if (this.isRewardXP) {
      this.xp = this.reward.xp
    } 
    if(!this.type || this.type === '') {this.isRewardTypeDialogOpen = true;}

  },
  computed: {
  	isRewardXP() {
  		return this.type === 'xp';
    },
    isRewardInfosheet() {
  		return this.type === 'infosheet';
    },
    isRewardObject() {
  		return this.type === 'object';
    },
    currentAccount() {
      return this.$store.getters['accounts/currentAccount'];
    },
    rewardContent() {
      let content= { "value":this.value,"type":this.type,"message":this.message }
      if (this.isRewardObject) {
        content= { ...content , object:this.object }
      } else if (this.isRewardXP) {
        content= { ...content , xp: this.xp }
      } 
      return content
    },
    infosheet(){
        if(!this.isRewardInfosheet || this.isRewardInfosheet && !this.value) return this.infosheetEmpty
       return this.$store.getters['infosheets/getInfosheetById'](this.value);
    },
    locale() {
      return this.$i18n.locale;
    },
    missions() {
      return this.$store.state.missions.missions;
    },
    path() {
      if(this.pathId) {
        return this.$store.getters['paths/getPathById'](this.pathId);
      }
      return null;
    },
    pathMissions() {
      return Object.fromEntries(
                Object.entries(this.missions)
                    .filter(e => this.path.missions
                      .map(m=>m.missionId)
                      .includes(e[0])
                   )
              )
    },
    //isFirstXPReward() {
    //  return Object.values(this.pathMissions).filter(m => m.rewards
    //                                        .filter(r=>r.type==="xp")
    //                                      ).length === 1;
    //},
    textDialogInformations() {
      return {
        propagateReward: {
          title: this.$t('rewards.textDialogInformations.propagateReward.title'),
          explanation: this.$t('rewards.textDialogInformations.propagateReward.explanation'),
          details: this.$t('rewards.textDialogInformations.propagateReward.details'),
          cancelButtonText: this.$t('rewards.textDialogInformations.propagateReward.cancel'),
          confirmButtonText: this.$t('rewards.textDialogInformations.propagateReward.confirm')
        }
      }
    },
    invalidRewardInformations() {
      let invalidInformations=[];
      console.log('typeof', typeof this.xp.value)
      //if(this.type==='xp') {
      //  if(this.xp.value < this.xp.errorValue) {
      //    invalidInformations=[... invalidInformations, {rewardType: 'xp', ruleType: 'maxvalue'}];
      //  }
      //}
      this.$emit('valid-reward-form', invalidInformations.length===0 && this.validRewardForm, this.rewardId);
      return invalidInformations;
    },
    rulesToShow() {
      if(this.invalidRewardInformations.length>0) {
        let rules=this.invalidRewardInformations.map(information=> this.rules[this.type][information.ruleType]);
        return rules;
      }
      return null;
    },
  },
  methods: {
    addRewardPicture() {
      this.infosheet.pictures = [...this.infosheet.pictures, {url:''}];
    },
    async setReward() {
      this.isRewardTypeDialogOpen=false;
      if (this.isRewardInfosheet) {
        this.value = await this.addInfosheet()
      }
      this.updateRewardContent()
      
    },
    updateInfosheetImages(file, index) {
      if (index !== undefined && file.url.length === 0) { // delete image
        this.infosheet.pictures.splice(index, 1);
      } else if (index !== undefined && file.url.length >0) { // change image
        this.infosheet.pictures[index] = file;
      }
      this.updateInfosheet(); 
    },
    
    updateObjectImage(img) {
      this.object.picture = img
      this.updateRewardContent();
    },
    updateObjectMedia(media) {
      this.object.media = media
      this.updateRewardContent();
    },
    uploadingMedia(isUploading, percentProgress) {
      this.$emit('uploading-media', isUploading, percentProgress);
    },
    updateRewardContent() { 
      if (this.isRewardXP) this.rewardContent.xp = Object.fromEntries(Object.entries(this.xp).map(([k,v])=> [k,parseInt(v)])) 
      this.$emit('update-reward', this.rewardContent, this.rewardId);
      //console.log('update reward', this.isRewardXP , this.isFirstXPReward , this.oldValue==='' ,  Number.isInteger(parseInt(this.value)))
      //if (this.isRewardXP && this.isFirstXPReward && this.oldValue==='' && Number.isInteger(parseInt(this.value)) ) {
      //  this.isXPDialogOpen = true
      //}
    },
    async addInfosheet() {
       try {
        console.log('addInfosheet', this.infosheet);
        this.$store.commit('app/SET_LOADING');
        const res = await this.$store.dispatch('infosheets/CREATE_INFOSHEET', {
          infosheetPayload: this.infosheet,
          index: 'clients', 
          kuzzle: this.$kuzzle
        });
        
        return res._id
      } catch (error) {
        // this.$toast.show(this.$t('infosheetForm.name'));
        this.$toast.show(JSON.stringify(error));
      }
    },
    async updateInfosheet() { 
       try {
        console.log('updateInfosheet');
        this.$store.commit('app/SET_LOADING');
        await this.$store.dispatch('infosheets/UPDATE_INFOSHEET', {
          infosheetId: this.value,
          infosheetPayload: this.infosheet,
          index: 'clients', 
          kuzzle: this.$kuzzle
        });
      } catch (error) {
        // this.$toast.show(this.$t('infosheetForm.name'));
        this.$toast.show(JSON.stringify(error));
      }
      this.$store.commit('app/UNSET_LOADING');
    
    },
    async deleteInfosheet() { 
      if (!this.$store.getters['infosheets/getInfosheetById'](this.value)) return
      try {
        console.log('deleteInfosheet');
        this.$store.commit('app/SET_LOADING');
        await this.$store.dispatch('infosheets/DELETE_INFOSHEET', {
          infosheetId: this.value,
          index: 'clients', 
          kuzzle: this.$kuzzle
        });
      } catch (error) {
        // this.$toast.show(this.$t('infosheetForm.name'));
        this.$toast.show(JSON.stringify(error));
      }
      this.$store.commit('app/UNSET_LOADING');
    
    },
    
    deleteReward() {
      console.log('delete');
      this.$emit('delete-reward', this.rewardId);
      this.isRewardTypeDialogOpen = false;
      if (this.isRewardInfosheet) {
        this.deleteInfosheet()
      }
    },

    propagateXP() {
      console.log('reward-xp', this.value)
      //this.$emit('reward-xp', this.value, this.xp.errorValue)
    },
    onImageError(error) {
      console.log('imageError', error.message);
    },
    async updateTranslatedText(textTranslated, type) {
      if(!textTranslated) return
      if(type==='name') {
        this.infosheet.name[this.langEdition]=textTranslated;
      }
      else if(type==='description') {
        this.infosheet.description[this.langEdition]=textTranslated;
      }
      else if(type==='funFact') {
        this.infosheet.funFact[this.langEdition]=textTranslated;        
      } else if(type==='text') {
        this.object.text[this.langEdition]=textTranslated;        
      }else if(type==='message') {
        this.message[this.langEdition]=textTranslated;        
      }
      this.updateRewardContent();
      
    }
  }
};
</script>

<style lang="sass">
  @import '../assets/_vars.scss'
  .layoutHeight
    height: 25vh

  .missionForm__reward
    margin-top: 0px; 
    margin-bottom: 15px; 
    height: 64px;

  .missionForm__reward .v-input--selection-controls__input
    display: none !important
    
  .missionForm__reward .v-input__control
    width:100% !important

  .MissionForm__rewardIcon
    width: 100px
    height: 100px
    border: 1px solid $secondary
    border-radius: 4px
    display: flex
    justify-content: center
    align-items: center
    margin: 1em 2em 1em 2em
    &:first-of-type
      margin-left: 0.2em
    i
      color: $secondary !important
  .MissionForm__rewardIcon--selected
    background: $primary

  .rewardTypeLabel
    margin: 0.3em 2em 1em 3.5em
    font-size: 10px
    line-height: 15px
    color: $secondary

  .addImage
    background: white
    cursor: pointer
    margin-top: 24px
    width: 150px !important
    height: 180px !important
    border: 2px dashed #009999
    display: flex
    justify-content: center
    align-items: center
   

</style>